import React, {  } from "react";
import type * as controls from "../PhoenixFormsV4.Controls";
import Button from "@mui/material/Button";
import PhoenixFormsV4Control from "./PhoenixFormsV4Control";
import PhoenixFormsV4ReadOnlyControl from "./PhoenixFormsV4ReadOnlyControl";

interface ReadOnlyProps {
  controlProps: controls.RepeatControl;
}
interface Props extends ReadOnlyProps {  
  addInstance: () => void;
  /** Passing PhoenixFormsV4Control onControlJump through to child RepeatObjects */
  parentControlJump: () => void;
};

const PhoenixRepeat = ({
  controlProps,
  addInstance,
  parentControlJump,
} : Props) => {

  /*
  full    - Repeat
  compact - Collapsible Repeat
  static  - Readonly Repeat
  */
  const appearance = controlProps.appearance ?? "full"; 

  return <div className="repeat">
    <div className="repeat-controls">
      {controlProps.controls.map((repeatObject) => <PhoenixFormsV4Control key={`repeatobject-${repeatObject.id}`} controlProps={repeatObject} parentControlProps={controlProps} onControlJump={parentControlJump} />)}
    </div>
    {appearance !== "static" &&
    <div>
      <Button
          className="repeat-add-button"
          onClick={addInstance}>
          Add
      </Button>
    </div>
    }
  </div>;
};

export const PhoenixRepeatReadOnly = ({
  controlProps,
} : ReadOnlyProps) => {

  return <div className="repeat">
    <div className="repeat-controls">
      {controlProps.controls.map((repeatObject) => <PhoenixFormsV4ReadOnlyControl key={`repeatobject-${repeatObject.id}`} controlProps={repeatObject} parentControlProps={controlProps} />)}
    </div>
  </div>;
};

export default PhoenixRepeat;